<template>
  <div class="result">
    <div class="row">
      <div class="col-xs-12 profile-image-container">
        <a :href="talent.profile.url">
          <img :src="talent.profile_image_url" alt="" />
        </a>
        <div class="checkbox checkbox-talent">
          <input type="checkbox" :id="`checkbox-${talent.id}`" @click.prevent="toggleTag">

          <label :for="`checkbox-${talent.id}`">
          <span class="tagged" v-if="tagStatus">
            <i class="fa fa-check"></i> Tagged
          </span>
            <span v-else>
            <i class="fa fa-plus"></i> Tag
          </span>
          </label>
        </div>
      </div>
      <div class="col-xs-12">
        <a class="details">
          <div class="main">
            <h2>{{ talent.first_name }}<br /> {{ talent.last_name }}</h2>
          </div>
        </a >
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    talent: {
      required: true,
      type: Object
    }
  },

  computed: {
    tagStatus () {
      return this.talent.is_tagged
    }
  },

  methods: {
    toggleTag () {
      if (this.tagStatus) {
        this.talent.is_tagged = false
        this.$emit('removeTagTalent', this.talent)
      } else {
        this.talent.is_tagged = true
        this.$emit('addTagTalent', this.talent)
      }
    }
  }
}
</script>
